import { Button } from "@material-ui/core";
import React from "react";
import PropTypes from "prop-types";
import styles from "./styles";
import ImageDefault from "../../../assets/images/esencial3D.png";
import { ImageAspectRatioRounded } from "@material-ui/icons";
import ImageCard from "../../ImageCard";
import { NavLink } from "react-router-dom";

const CardPlan = ({ plan }) => {
  const classes = styles();

  const getUrlImage = images => {
    return images.find(img => img.type === "card")?.url || ImageDefault;
  };
  return (
    <div className={classes.cardContainer}>
      <div className={"cardImage"}>
        <ImageCard url={getUrlImage(plan.images)} />
      </div>
      <div className={"cardIDescription"}>
        <div className={classes.cardTitle}>{plan.name}</div>
        <div className={classes.cardSubtitle}>{plan.subtitle}</div>
        <div>
          <NavLink
            to={`/como-usar-tu-plan/planes/${plan.id}`}
            className={classes.btnPlanSlider}
          >
            Conoce más
          </NavLink>

          {/* <Button
            href={`${process.env.REACT_APP_URL_HOST}/`}
            className={classes.primaryButton}
            variant="contained"
          >
            Conoce más
          </Button> */}
        </div>
      </div>
    </div>
  );
};
CardPlan.propTypes = {
  plan: PropTypes.object
};
export default CardPlan;
